module.exports = __webpack_public_path__ + "static/img_caracteristicas-2ea870b78e4d8d42fbf7e491cbcd67cf.png";